import { render, staticRenderFns } from "./factoryComponent.vue?vue&type=template&id=40893354&scoped=true&"
import script from "./factoryComponent.vue?vue&type=script&lang=js&"
export * from "./factoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40893354",
  null
  
)

export default component.exports